/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationQueryKey,
  ServiceOperationUseMutationOptions,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  Mutation,
  MutationCache,
  MutationState,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseMutationResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface AgentBlocksService {
  /** @summary List */
  listBlocks: {
    /** @summary List */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<ListBlocksSchema, ListBlocksParameters, TMeta, TSignal>
        | (QueryFnOptionsByParameters<ListBlocksParameters, TMeta, TSignal> | void),
      client?: (
        schema: ListBlocksSchema,
        options: {
          parameters: ListBlocksParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<ListBlocksData, ListBlocksError>>
    ): Promise<RequestFnResponse<ListBlocksData, ListBlocksError>>;
    /** @summary List */
    getQueryKey(
      parameters: DeepReadonly<ListBlocksParameters> | void
    ): ServiceOperationQueryKey<ListBlocksSchema, ListBlocksParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary List
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.agentBlocksService.listBlocks.useQuery()
     * ```
     */
    useQuery<TData = ListBlocksData>(
      parameters:
        | ServiceOperationQueryKey<ListBlocksSchema, ListBlocksParameters>
        | (DeepReadonly<ListBlocksParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          ListBlocksData,
          ListBlocksError,
          TData,
          ServiceOperationQueryKey<ListBlocksSchema, ListBlocksParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<ListBlocksError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary List
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.agentBlocksService.listBlocks.useQuery()
     * ```
     */
    useQuery<TData = ListBlocksData>(
      parameters:
        | ServiceOperationQueryKey<ListBlocksSchema, ListBlocksParameters>
        | (DeepReadonly<ListBlocksParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          ListBlocksData,
          ListBlocksError,
          TData,
          ServiceOperationQueryKey<ListBlocksSchema, ListBlocksParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<ListBlocksError>>;
    /** @summary List */
    getInfiniteQueryKey(
      parameters: DeepReadonly<ListBlocksParameters> | void
    ): ServiceOperationInfiniteQueryKey<ListBlocksSchema, ListBlocksParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary List
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.agentBlocksService.listBlocks.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListBlocksParameters,
      TQueryFnData = ListBlocksData,
      TData = OperationInfiniteData<TQueryFnData, ListBlocksParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListBlocksSchema, ListBlocksParameters>
        | (DeepReadonly<ListBlocksParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListBlocksError,
          TData,
          ServiceOperationInfiniteQueryKey<ListBlocksSchema, ListBlocksParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<ListBlocksError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary List
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.agentBlocksService.listBlocks.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListBlocksParameters,
      TQueryFnData = ListBlocksData,
      TData = OperationInfiniteData<TQueryFnData, ListBlocksParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListBlocksSchema, ListBlocksParameters>
        | (DeepReadonly<ListBlocksParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListBlocksError,
          TData,
          ServiceOperationInfiniteQueryKey<ListBlocksSchema, ListBlocksParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<ListBlocksData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<ListBlocksError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary List
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const listBlocksTotal = qraft.agentBlocksService.listBlocks.useIsFetching()
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<ListBlocksSchema, ListBlocksData, TInfinite, ListBlocksParameters, ListBlocksError>
        | QueryFiltersByQueryKey<ListBlocksSchema, ListBlocksData, TInfinite, ListBlocksParameters, ListBlocksError>
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary List
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const listBlocksResults = qraft.agentBlocksService.listBlocks.useQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listBlocksResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const listBlocksCombinedResults = qraft.agentBlocksService.listBlocks.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listBlocksCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<ListBlocksSchema, ListBlocksParameters, ListBlocksData, ListBlocksError>
      >,
      TCombinedResult = Array<UseQueryResult<ListBlocksData, ListBlocksError>>,
    >(options: {
      queries: T;
      combine?: (results: Array<UseQueryResult<ListBlocksData, ListBlocksError>>) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary List
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.agentBlocksService.listBlocks.useSuspenseQuery()
     * ```
     */
    useSuspenseQuery<TData = ListBlocksData>(
      parameters:
        | ServiceOperationQueryKey<ListBlocksSchema, ListBlocksParameters>
        | (DeepReadonly<ListBlocksParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          ListBlocksData,
          ListBlocksError,
          TData,
          ServiceOperationQueryKey<ListBlocksSchema, ListBlocksParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<ListBlocksError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary List
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.agentBlocksService.listBlocks.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends ListBlocksParameters, TData = ListBlocksData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListBlocksSchema, ListBlocksParameters>
        | (DeepReadonly<ListBlocksParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          ListBlocksData,
          ListBlocksError,
          OperationInfiniteData<TData, ListBlocksParameters>,
          ServiceOperationInfiniteQueryKey<ListBlocksSchema, ListBlocksParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<ListBlocksData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, ListBlocksParameters>,
      OperationError<ListBlocksError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary List
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const listBlocksData = qraft.agentBlocksService.listBlocks.useSuspenseQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listBlocksResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const listBlocksCombinedData = qraft.agentBlocksService.listBlocks.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * listBlocksCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<ListBlocksSchema, ListBlocksParameters, ListBlocksData, ListBlocksError>
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<ListBlocksData, ListBlocksError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<WithOptional<UseSuspenseQueryResult<ListBlocksData, ListBlocksError>, 'data'>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary List */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListBlocksSchema,
        ListBlocksData,
        ListBlocksParameters,
        ListBlocksError
      > | void
    ): Promise<ListBlocksData>;
    /** @summary List */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListBlocksSchema,
        ListBlocksData,
        ListBlocksParameters,
        ListBlocksError
      > | void
    ): Promise<void>;
    /** @summary List */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        ListBlocksSchema,
        ListBlocksData,
        ListBlocksParameters,
        ListBlocksError
      > | void
    ): Promise<ListBlocksData>;
    /** @summary List */
    fetchInfiniteQuery<TPageParam extends ListBlocksParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListBlocksSchema,
        ListBlocksData,
        ListBlocksParameters,
        DeepReadonly<TPageParam>,
        ListBlocksError
      > | void
    ): Promise<OperationInfiniteData<ListBlocksData, ListBlocksParameters>>;
    /** @summary List */
    prefetchInfiniteQuery<TPageParam extends ListBlocksParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListBlocksSchema,
        ListBlocksData,
        ListBlocksParameters,
        DeepReadonly<TPageParam>,
        ListBlocksError
      > | void
    ): Promise<void>;
    /** @summary List */
    ensureInfiniteQueryData<TPageParam extends ListBlocksParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        ListBlocksSchema,
        ListBlocksData,
        ListBlocksParameters,
        DeepReadonly<TPageParam>,
        ListBlocksError
      > | void
    ): Promise<OperationInfiniteData<ListBlocksData, ListBlocksParameters>>;
    /** @summary List */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<ListBlocksSchema, ListBlocksParameters>
        | (DeepReadonly<ListBlocksParameters> | void)
    ): ListBlocksData | undefined;
    /** @summary List */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<ListBlocksSchema, ListBlocksParameters>
        | (DeepReadonly<ListBlocksParameters> | void)
    ): OperationInfiniteData<ListBlocksData, ListBlocksParameters> | undefined;
    /** @summary List */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<ListBlocksSchema, ListBlocksData, TInfinite, ListBlocksParameters, ListBlocksError>
        | QueryFiltersByQueryKey<ListBlocksSchema, ListBlocksData, TInfinite, ListBlocksParameters, ListBlocksError>
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<ListBlocksSchema, ListBlocksParameters>,
            data: NoInfer<OperationInfiniteData<ListBlocksData, ListBlocksParameters>> | undefined,
          ]
        >
      : Array<
          [queryKey: ServiceOperationQueryKey<ListBlocksSchema, ListBlocksParameters>, data: ListBlocksData | undefined]
        >;
    /** @summary List */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<ListBlocksSchema, ListBlocksParameters>
        | (DeepReadonly<ListBlocksParameters> | void)
    ): QueryState<ListBlocksData, ListBlocksError> | undefined;
    /** @summary List */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<ListBlocksParameters>
        | ServiceOperationInfiniteQueryKey<ListBlocksSchema, ListBlocksParameters>
        | void
    ): QueryState<OperationInfiniteData<ListBlocksData, ListBlocksParameters>, ListBlocksError> | undefined;
    /** @summary List */
    setQueryData(
      parameters:
        | (DeepReadonly<ListBlocksParameters> | undefined)
        | ServiceOperationQueryKey<ListBlocksSchema, ListBlocksParameters>,
      updater: Updater<NoInfer<ListBlocksData> | undefined, NoInfer<DeepReadonly<ListBlocksData>> | undefined>,
      options?: SetDataOptions
    ): ListBlocksData | undefined;
    /** @summary List */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<ListBlocksParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<ListBlocksSchema, ListBlocksParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<ListBlocksData, ListBlocksParameters>> | undefined,
        NoInfer<DeepReadonly<OperationInfiniteData<ListBlocksData, ListBlocksParameters>>> | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<ListBlocksData, ListBlocksParameters> | undefined;
    /** @summary List */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<ListBlocksSchema, ListBlocksData, TInfinite, ListBlocksParameters, ListBlocksError>
        | QueryFiltersByQueryKey<ListBlocksSchema, ListBlocksData, TInfinite, ListBlocksParameters, ListBlocksError>,
      updater: Updater<NoInfer<ListBlocksData> | undefined, NoInfer<ListBlocksData> | undefined>,
      options?: SetDataOptions
    ): Array<ListBlocksData | undefined>;
    /** @summary List */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        ListBlocksSchema,
        ListBlocksData,
        TInfinite,
        ListBlocksParameters,
        ListBlocksError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary List */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<ListBlocksSchema, ListBlocksData, TInfinite, ListBlocksParameters, ListBlocksError>
        | QueryFiltersByQueryKey<ListBlocksSchema, ListBlocksData, TInfinite, ListBlocksParameters, ListBlocksError>,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary List */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<ListBlocksSchema, ListBlocksData, TInfinite, ListBlocksParameters, ListBlocksError>
        | QueryFiltersByQueryKey<ListBlocksSchema, ListBlocksData, TInfinite, ListBlocksParameters, ListBlocksError>,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary List */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<ListBlocksSchema, ListBlocksData, TInfinite, ListBlocksParameters, ListBlocksError>
        | QueryFiltersByQueryKey<ListBlocksSchema, ListBlocksData, TInfinite, ListBlocksParameters, ListBlocksError>
    ): void;
    /** @summary List */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<ListBlocksSchema, ListBlocksData, TInfinite, ListBlocksParameters, ListBlocksError>
        | QueryFiltersByQueryKey<ListBlocksSchema, ListBlocksData, TInfinite, ListBlocksParameters, ListBlocksError>,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary List */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<ListBlocksSchema, ListBlocksData, TInfinite, ListBlocksParameters, ListBlocksError>
        | QueryFiltersByQueryKey<ListBlocksSchema, ListBlocksData, TInfinite, ListBlocksParameters, ListBlocksError>
    ): number;
    schema: ListBlocksSchema;
    types: {
      parameters: ListBlocksParameters;
      data: ListBlocksData;
      error: ListBlocksError;
    };
  };
  /** @summary Create */
  createBlock: {
    /** @summary Create */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<CreateBlockBody, CreateBlockParameters, TMeta, TSignal>,
      client?: (
        schema: CreateBlockSchema,
        options: ServiceOperationMutationFnOptions<CreateBlockBody, CreateBlockParameters, TMeta, TSignal>
      ) => Promise<RequestFnResponse<CreateBlockData, CreateBlockError>>
    ): Promise<RequestFnResponse<CreateBlockData, CreateBlockError>>;
    /** @summary Create */
    getMutationKey(
      parameters: DeepReadonly<CreateBlockParameters> | void
    ): ServiceOperationMutationKey<CreateBlockSchema, CreateBlockParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentBlocksService.createBlock.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentBlocksService.createBlock.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends CreateBlockBody, TContext = unknown>(
      parameters: DeepReadonly<CreateBlockParameters>,
      options?: ServiceOperationUseMutationOptions<
        CreateBlockSchema,
        CreateBlockData,
        CreateBlockParameters,
        TVariables,
        OperationError<CreateBlockError>,
        TContext
      >
    ): UseMutationResult<CreateBlockData, OperationError<CreateBlockError>, TVariables, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentBlocksService.createBlock.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentBlocksService.createBlock.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends MutationVariables<CreateBlockBody, CreateBlockParameters>, TContext = unknown>(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CreateBlockSchema,
        CreateBlockData,
        CreateBlockParameters,
        TVariables,
        OperationError<CreateBlockError>,
        TContext
      >
    ): UseMutationResult<CreateBlockData, OperationError<CreateBlockError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const createBlockTotal = qraft.agentBlocksService.createBlock.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const createBlockTotal = qraft.agentBlocksService.createBlock.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CreateBlockBody,
            CreateBlockData,
            CreateBlockParameters,
            OperationError<CreateBlockError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateBlockSchema,
            CreateBlockBody,
            CreateBlockData,
            CreateBlockParameters,
            OperationError<CreateBlockError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const createBlockPendingMutationVariables = qraft.agentBlocksService.createBlock.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const createBlockMutationData = qraft.agentBlocksService.createBlock.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CreateBlockData,
        OperationError<CreateBlockError>,
        MutationVariables<CreateBlockBody, CreateBlockParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CreateBlockBody,
            CreateBlockData,
            CreateBlockParameters,
            OperationError<CreateBlockError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateBlockSchema,
            CreateBlockBody,
            CreateBlockData,
            CreateBlockParameters,
            OperationError<CreateBlockError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CreateBlockData,
          OperationError<CreateBlockError>,
          MutationVariables<CreateBlockBody, CreateBlockParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Create */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CreateBlockBody,
            CreateBlockData,
            CreateBlockParameters,
            OperationError<CreateBlockError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateBlockSchema,
            CreateBlockBody,
            CreateBlockData,
            CreateBlockParameters,
            OperationError<CreateBlockError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentBlocksService.createBlock.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentBlocksService.createBlock.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CreateBlockBody,
              CreateBlockData,
              CreateBlockParameters,
              OperationError<CreateBlockError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateBlockSchema,
              CreateBlockBody,
              CreateBlockData,
              CreateBlockParameters,
              OperationError<CreateBlockError>,
              TContext
            >
      ):
        | Mutation<
            CreateBlockData,
            CreateBlockError,
            MutationVariables<CreateBlockBody, CreateBlockParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CreateBlockBody,
              CreateBlockData,
              CreateBlockParameters,
              OperationError<CreateBlockError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateBlockSchema,
              CreateBlockBody,
              CreateBlockData,
              CreateBlockParameters,
              OperationError<CreateBlockError>,
              TContext
            >
      ): Array<
        Mutation<CreateBlockData, CreateBlockError, MutationVariables<CreateBlockBody, CreateBlockParameters>, TContext>
      >;
    };
    schema: CreateBlockSchema;
    types: {
      parameters: CreateBlockParameters;
      data: CreateBlockData;
      error: CreateBlockError;
      body: CreateBlockBody;
    };
  };
  /** @summary Template Context */
  getTemplateContext: {
    /** @summary Template Context */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<GetTemplateContextSchema, GetTemplateContextParameters, TMeta, TSignal>
        | (QueryFnOptionsByParameters<GetTemplateContextParameters, TMeta, TSignal> | void),
      client?: (
        schema: GetTemplateContextSchema,
        options: {
          parameters: GetTemplateContextParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<GetTemplateContextData, GetTemplateContextError>>
    ): Promise<RequestFnResponse<GetTemplateContextData, GetTemplateContextError>>;
    /** @summary Template Context */
    getQueryKey(
      parameters: DeepReadonly<GetTemplateContextParameters> | void
    ): ServiceOperationQueryKey<GetTemplateContextSchema, GetTemplateContextParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Template Context
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.agentBlocksService.getTemplateContext.useQuery()
     * ```
     */
    useQuery<TData = GetTemplateContextData>(
      parameters:
        | ServiceOperationQueryKey<GetTemplateContextSchema, GetTemplateContextParameters>
        | (DeepReadonly<GetTemplateContextParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          GetTemplateContextData,
          GetTemplateContextError,
          TData,
          ServiceOperationQueryKey<GetTemplateContextSchema, GetTemplateContextParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetTemplateContextError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Template Context
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.agentBlocksService.getTemplateContext.useQuery()
     * ```
     */
    useQuery<TData = GetTemplateContextData>(
      parameters:
        | ServiceOperationQueryKey<GetTemplateContextSchema, GetTemplateContextParameters>
        | (DeepReadonly<GetTemplateContextParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          GetTemplateContextData,
          GetTemplateContextError,
          TData,
          ServiceOperationQueryKey<GetTemplateContextSchema, GetTemplateContextParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetTemplateContextError>>;
    /** @summary Template Context */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetTemplateContextParameters> | void
    ): ServiceOperationInfiniteQueryKey<GetTemplateContextSchema, GetTemplateContextParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Template Context
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.agentBlocksService.getTemplateContext.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetTemplateContextParameters,
      TQueryFnData = GetTemplateContextData,
      TData = OperationInfiniteData<TQueryFnData, GetTemplateContextParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetTemplateContextSchema, GetTemplateContextParameters>
        | (DeepReadonly<GetTemplateContextParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetTemplateContextError,
          TData,
          ServiceOperationInfiniteQueryKey<GetTemplateContextSchema, GetTemplateContextParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetTemplateContextError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Template Context
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.agentBlocksService.getTemplateContext.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetTemplateContextParameters,
      TQueryFnData = GetTemplateContextData,
      TData = OperationInfiniteData<TQueryFnData, GetTemplateContextParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetTemplateContextSchema, GetTemplateContextParameters>
        | (DeepReadonly<GetTemplateContextParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetTemplateContextError,
          TData,
          ServiceOperationInfiniteQueryKey<GetTemplateContextSchema, GetTemplateContextParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetTemplateContextData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetTemplateContextError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Template Context
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getTemplateContextTotal = qraft.agentBlocksService.getTemplateContext.useIsFetching()
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetTemplateContextSchema,
            GetTemplateContextData,
            TInfinite,
            GetTemplateContextParameters,
            GetTemplateContextError
          >
        | QueryFiltersByQueryKey<
            GetTemplateContextSchema,
            GetTemplateContextData,
            TInfinite,
            GetTemplateContextParameters,
            GetTemplateContextError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Template Context
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getTemplateContextResults = qraft.agentBlocksService.getTemplateContext.useQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getTemplateContextResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getTemplateContextCombinedResults = qraft.agentBlocksService.getTemplateContext.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getTemplateContextCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetTemplateContextSchema,
          GetTemplateContextParameters,
          GetTemplateContextData,
          GetTemplateContextError
        >
      >,
      TCombinedResult = Array<UseQueryResult<GetTemplateContextData, GetTemplateContextError>>,
    >(options: {
      queries: T;
      combine?: (results: Array<UseQueryResult<GetTemplateContextData, GetTemplateContextError>>) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Template Context
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.agentBlocksService.getTemplateContext.useSuspenseQuery()
     * ```
     */
    useSuspenseQuery<TData = GetTemplateContextData>(
      parameters:
        | ServiceOperationQueryKey<GetTemplateContextSchema, GetTemplateContextParameters>
        | (DeepReadonly<GetTemplateContextParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          GetTemplateContextData,
          GetTemplateContextError,
          TData,
          ServiceOperationQueryKey<GetTemplateContextSchema, GetTemplateContextParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetTemplateContextError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Template Context
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.agentBlocksService.getTemplateContext.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends GetTemplateContextParameters, TData = GetTemplateContextData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetTemplateContextSchema, GetTemplateContextParameters>
        | (DeepReadonly<GetTemplateContextParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetTemplateContextData,
          GetTemplateContextError,
          OperationInfiniteData<TData, GetTemplateContextParameters>,
          ServiceOperationInfiniteQueryKey<GetTemplateContextSchema, GetTemplateContextParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetTemplateContextData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetTemplateContextParameters>,
      OperationError<GetTemplateContextError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Template Context
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getTemplateContextData = qraft.agentBlocksService.getTemplateContext.useSuspenseQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getTemplateContextResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getTemplateContextCombinedData = qraft.agentBlocksService.getTemplateContext.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getTemplateContextCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetTemplateContextSchema,
          GetTemplateContextParameters,
          GetTemplateContextData,
          GetTemplateContextError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<GetTemplateContextData, GetTemplateContextError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<WithOptional<UseSuspenseQueryResult<GetTemplateContextData, GetTemplateContextError>, 'data'>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Template Context */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetTemplateContextSchema,
        GetTemplateContextData,
        GetTemplateContextParameters,
        GetTemplateContextError
      > | void
    ): Promise<GetTemplateContextData>;
    /** @summary Template Context */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetTemplateContextSchema,
        GetTemplateContextData,
        GetTemplateContextParameters,
        GetTemplateContextError
      > | void
    ): Promise<void>;
    /** @summary Template Context */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetTemplateContextSchema,
        GetTemplateContextData,
        GetTemplateContextParameters,
        GetTemplateContextError
      > | void
    ): Promise<GetTemplateContextData>;
    /** @summary Template Context */
    fetchInfiniteQuery<TPageParam extends GetTemplateContextParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetTemplateContextSchema,
        GetTemplateContextData,
        GetTemplateContextParameters,
        DeepReadonly<TPageParam>,
        GetTemplateContextError
      > | void
    ): Promise<OperationInfiniteData<GetTemplateContextData, GetTemplateContextParameters>>;
    /** @summary Template Context */
    prefetchInfiniteQuery<TPageParam extends GetTemplateContextParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetTemplateContextSchema,
        GetTemplateContextData,
        GetTemplateContextParameters,
        DeepReadonly<TPageParam>,
        GetTemplateContextError
      > | void
    ): Promise<void>;
    /** @summary Template Context */
    ensureInfiniteQueryData<TPageParam extends GetTemplateContextParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetTemplateContextSchema,
        GetTemplateContextData,
        GetTemplateContextParameters,
        DeepReadonly<TPageParam>,
        GetTemplateContextError
      > | void
    ): Promise<OperationInfiniteData<GetTemplateContextData, GetTemplateContextParameters>>;
    /** @summary Template Context */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<GetTemplateContextSchema, GetTemplateContextParameters>
        | (DeepReadonly<GetTemplateContextParameters> | void)
    ): GetTemplateContextData | undefined;
    /** @summary Template Context */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetTemplateContextSchema, GetTemplateContextParameters>
        | (DeepReadonly<GetTemplateContextParameters> | void)
    ): OperationInfiniteData<GetTemplateContextData, GetTemplateContextParameters> | undefined;
    /** @summary Template Context */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetTemplateContextSchema,
            GetTemplateContextData,
            TInfinite,
            GetTemplateContextParameters,
            GetTemplateContextError
          >
        | QueryFiltersByQueryKey<
            GetTemplateContextSchema,
            GetTemplateContextData,
            TInfinite,
            GetTemplateContextParameters,
            GetTemplateContextError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<GetTemplateContextSchema, GetTemplateContextParameters>,
            data: NoInfer<OperationInfiniteData<GetTemplateContextData, GetTemplateContextParameters>> | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<GetTemplateContextSchema, GetTemplateContextParameters>,
            data: GetTemplateContextData | undefined,
          ]
        >;
    /** @summary Template Context */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<GetTemplateContextSchema, GetTemplateContextParameters>
        | (DeepReadonly<GetTemplateContextParameters> | void)
    ): QueryState<GetTemplateContextData, GetTemplateContextError> | undefined;
    /** @summary Template Context */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetTemplateContextParameters>
        | ServiceOperationInfiniteQueryKey<GetTemplateContextSchema, GetTemplateContextParameters>
        | void
    ):
      | QueryState<OperationInfiniteData<GetTemplateContextData, GetTemplateContextParameters>, GetTemplateContextError>
      | undefined;
    /** @summary Template Context */
    setQueryData(
      parameters:
        | (DeepReadonly<GetTemplateContextParameters> | undefined)
        | ServiceOperationQueryKey<GetTemplateContextSchema, GetTemplateContextParameters>,
      updater: Updater<
        NoInfer<GetTemplateContextData> | undefined,
        NoInfer<DeepReadonly<GetTemplateContextData>> | undefined
      >,
      options?: SetDataOptions
    ): GetTemplateContextData | undefined;
    /** @summary Template Context */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<GetTemplateContextParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<GetTemplateContextSchema, GetTemplateContextParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<GetTemplateContextData, GetTemplateContextParameters>> | undefined,
        NoInfer<DeepReadonly<OperationInfiniteData<GetTemplateContextData, GetTemplateContextParameters>>> | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<GetTemplateContextData, GetTemplateContextParameters> | undefined;
    /** @summary Template Context */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetTemplateContextSchema,
            GetTemplateContextData,
            TInfinite,
            GetTemplateContextParameters,
            GetTemplateContextError
          >
        | QueryFiltersByQueryKey<
            GetTemplateContextSchema,
            GetTemplateContextData,
            TInfinite,
            GetTemplateContextParameters,
            GetTemplateContextError
          >,
      updater: Updater<NoInfer<GetTemplateContextData> | undefined, NoInfer<GetTemplateContextData> | undefined>,
      options?: SetDataOptions
    ): Array<GetTemplateContextData | undefined>;
    /** @summary Template Context */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetTemplateContextSchema,
        GetTemplateContextData,
        TInfinite,
        GetTemplateContextParameters,
        GetTemplateContextError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Template Context */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetTemplateContextSchema,
            GetTemplateContextData,
            TInfinite,
            GetTemplateContextParameters,
            GetTemplateContextError
          >
        | QueryFiltersByQueryKey<
            GetTemplateContextSchema,
            GetTemplateContextData,
            TInfinite,
            GetTemplateContextParameters,
            GetTemplateContextError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Template Context */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetTemplateContextSchema,
            GetTemplateContextData,
            TInfinite,
            GetTemplateContextParameters,
            GetTemplateContextError
          >
        | QueryFiltersByQueryKey<
            GetTemplateContextSchema,
            GetTemplateContextData,
            TInfinite,
            GetTemplateContextParameters,
            GetTemplateContextError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Template Context */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetTemplateContextSchema,
            GetTemplateContextData,
            TInfinite,
            GetTemplateContextParameters,
            GetTemplateContextError
          >
        | QueryFiltersByQueryKey<
            GetTemplateContextSchema,
            GetTemplateContextData,
            TInfinite,
            GetTemplateContextParameters,
            GetTemplateContextError
          >
    ): void;
    /** @summary Template Context */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetTemplateContextSchema,
            GetTemplateContextData,
            TInfinite,
            GetTemplateContextParameters,
            GetTemplateContextError
          >
        | QueryFiltersByQueryKey<
            GetTemplateContextSchema,
            GetTemplateContextData,
            TInfinite,
            GetTemplateContextParameters,
            GetTemplateContextError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Template Context */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetTemplateContextSchema,
            GetTemplateContextData,
            TInfinite,
            GetTemplateContextParameters,
            GetTemplateContextError
          >
        | QueryFiltersByQueryKey<
            GetTemplateContextSchema,
            GetTemplateContextData,
            TInfinite,
            GetTemplateContextParameters,
            GetTemplateContextError
          >
    ): number;
    schema: GetTemplateContextSchema;
    types: {
      parameters: GetTemplateContextParameters;
      data: GetTemplateContextData;
      error: GetTemplateContextError;
    };
  };
  /** @summary Preview */
  previewBlock: {
    /** @summary Preview */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<PreviewBlockBody, PreviewBlockParameters, TMeta, TSignal>,
      client?: (
        schema: PreviewBlockSchema,
        options: ServiceOperationMutationFnOptions<PreviewBlockBody, PreviewBlockParameters, TMeta, TSignal>
      ) => Promise<RequestFnResponse<PreviewBlockData, PreviewBlockError>>
    ): Promise<RequestFnResponse<PreviewBlockData, PreviewBlockError>>;
    /** @summary Preview */
    getMutationKey(
      parameters: DeepReadonly<PreviewBlockParameters> | void
    ): ServiceOperationMutationKey<PreviewBlockSchema, PreviewBlockParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Preview
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentBlocksService.previewBlock.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentBlocksService.previewBlock.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends PreviewBlockBody, TContext = unknown>(
      parameters: DeepReadonly<PreviewBlockParameters>,
      options?: ServiceOperationUseMutationOptions<
        PreviewBlockSchema,
        PreviewBlockData,
        PreviewBlockParameters,
        TVariables,
        OperationError<PreviewBlockError>,
        TContext
      >
    ): UseMutationResult<PreviewBlockData, OperationError<PreviewBlockError>, TVariables, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Preview
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentBlocksService.previewBlock.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentBlocksService.previewBlock.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends MutationVariables<PreviewBlockBody, PreviewBlockParameters>, TContext = unknown>(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        PreviewBlockSchema,
        PreviewBlockData,
        PreviewBlockParameters,
        TVariables,
        OperationError<PreviewBlockError>,
        TContext
      >
    ): UseMutationResult<PreviewBlockData, OperationError<PreviewBlockError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Preview
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const previewBlockTotal = qraft.agentBlocksService.previewBlock.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const previewBlockTotal = qraft.agentBlocksService.previewBlock.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            PreviewBlockBody,
            PreviewBlockData,
            PreviewBlockParameters,
            OperationError<PreviewBlockError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            PreviewBlockSchema,
            PreviewBlockBody,
            PreviewBlockData,
            PreviewBlockParameters,
            OperationError<PreviewBlockError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Preview
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const previewBlockPendingMutationVariables = qraft.agentBlocksService.previewBlock.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const previewBlockMutationData = qraft.agentBlocksService.previewBlock.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        PreviewBlockData,
        OperationError<PreviewBlockError>,
        MutationVariables<PreviewBlockBody, PreviewBlockParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            PreviewBlockBody,
            PreviewBlockData,
            PreviewBlockParameters,
            OperationError<PreviewBlockError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            PreviewBlockSchema,
            PreviewBlockBody,
            PreviewBlockData,
            PreviewBlockParameters,
            OperationError<PreviewBlockError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          PreviewBlockData,
          OperationError<PreviewBlockError>,
          MutationVariables<PreviewBlockBody, PreviewBlockParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Preview */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            PreviewBlockBody,
            PreviewBlockData,
            PreviewBlockParameters,
            OperationError<PreviewBlockError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            PreviewBlockSchema,
            PreviewBlockBody,
            PreviewBlockData,
            PreviewBlockParameters,
            OperationError<PreviewBlockError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Preview
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentBlocksService.previewBlock.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentBlocksService.previewBlock.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              PreviewBlockBody,
              PreviewBlockData,
              PreviewBlockParameters,
              OperationError<PreviewBlockError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              PreviewBlockSchema,
              PreviewBlockBody,
              PreviewBlockData,
              PreviewBlockParameters,
              OperationError<PreviewBlockError>,
              TContext
            >
      ):
        | Mutation<
            PreviewBlockData,
            PreviewBlockError,
            MutationVariables<PreviewBlockBody, PreviewBlockParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              PreviewBlockBody,
              PreviewBlockData,
              PreviewBlockParameters,
              OperationError<PreviewBlockError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              PreviewBlockSchema,
              PreviewBlockBody,
              PreviewBlockData,
              PreviewBlockParameters,
              OperationError<PreviewBlockError>,
              TContext
            >
      ): Array<
        Mutation<
          PreviewBlockData,
          PreviewBlockError,
          MutationVariables<PreviewBlockBody, PreviewBlockParameters>,
          TContext
        >
      >;
    };
    schema: PreviewBlockSchema;
    types: {
      parameters: PreviewBlockParameters;
      data: PreviewBlockData;
      error: PreviewBlockError;
      body: PreviewBlockBody;
    };
  };
  /** @summary Update */
  updateBlock: {
    /** @summary Update */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<UpdateBlockBody, UpdateBlockParameters, TMeta, TSignal>,
      client?: (
        schema: UpdateBlockSchema,
        options: ServiceOperationMutationFnOptions<UpdateBlockBody, UpdateBlockParameters, TMeta, TSignal>
      ) => Promise<RequestFnResponse<UpdateBlockData, UpdateBlockError>>
    ): Promise<RequestFnResponse<UpdateBlockData, UpdateBlockError>>;
    /** @summary Update */
    getMutationKey(
      parameters: DeepReadonly<UpdateBlockParameters> | void
    ): ServiceOperationMutationKey<UpdateBlockSchema, UpdateBlockParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentBlocksService.updateBlock.useMutation({
     *     path: {
     *         block_id: blockId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentBlocksService.updateBlock.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         block_id: blockId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends UpdateBlockBody, TContext = unknown>(
      parameters: DeepReadonly<UpdateBlockParameters>,
      options?: ServiceOperationUseMutationOptions<
        UpdateBlockSchema,
        UpdateBlockData,
        UpdateBlockParameters,
        TVariables,
        OperationError<UpdateBlockError>,
        TContext
      >
    ): UseMutationResult<UpdateBlockData, OperationError<UpdateBlockError>, TVariables, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.agentBlocksService.updateBlock.useMutation({
     *     path: {
     *         block_id: blockId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.agentBlocksService.updateBlock.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         block_id: blockId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends MutationVariables<UpdateBlockBody, UpdateBlockParameters>, TContext = unknown>(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        UpdateBlockSchema,
        UpdateBlockData,
        UpdateBlockParameters,
        TVariables,
        OperationError<UpdateBlockError>,
        TContext
      >
    ): UseMutationResult<UpdateBlockData, OperationError<UpdateBlockError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const updateBlockTotal = qraft.agentBlocksService.updateBlock.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const updateBlockTotal = qraft.agentBlocksService.updateBlock.useIsMutating({
     *     parameters: {
     *         path: {
     *             block_id: blockId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            UpdateBlockBody,
            UpdateBlockData,
            UpdateBlockParameters,
            OperationError<UpdateBlockError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateBlockSchema,
            UpdateBlockBody,
            UpdateBlockData,
            UpdateBlockParameters,
            OperationError<UpdateBlockError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const updateBlockPendingMutationVariables = qraft.agentBlocksService.updateBlock.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const updateBlockMutationData = qraft.agentBlocksService.updateBlock.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 block_id: blockId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        UpdateBlockData,
        OperationError<UpdateBlockError>,
        MutationVariables<UpdateBlockBody, UpdateBlockParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            UpdateBlockBody,
            UpdateBlockData,
            UpdateBlockParameters,
            OperationError<UpdateBlockError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateBlockSchema,
            UpdateBlockBody,
            UpdateBlockData,
            UpdateBlockParameters,
            OperationError<UpdateBlockError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          UpdateBlockData,
          OperationError<UpdateBlockError>,
          MutationVariables<UpdateBlockBody, UpdateBlockParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Update */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            UpdateBlockBody,
            UpdateBlockData,
            UpdateBlockParameters,
            OperationError<UpdateBlockError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateBlockSchema,
            UpdateBlockBody,
            UpdateBlockData,
            UpdateBlockParameters,
            OperationError<UpdateBlockError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.agentBlocksService.updateBlock.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             block_id: blockId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.agentBlocksService.updateBlock.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              UpdateBlockBody,
              UpdateBlockData,
              UpdateBlockParameters,
              OperationError<UpdateBlockError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateBlockSchema,
              UpdateBlockBody,
              UpdateBlockData,
              UpdateBlockParameters,
              OperationError<UpdateBlockError>,
              TContext
            >
      ):
        | Mutation<
            UpdateBlockData,
            UpdateBlockError,
            MutationVariables<UpdateBlockBody, UpdateBlockParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              UpdateBlockBody,
              UpdateBlockData,
              UpdateBlockParameters,
              OperationError<UpdateBlockError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateBlockSchema,
              UpdateBlockBody,
              UpdateBlockData,
              UpdateBlockParameters,
              OperationError<UpdateBlockError>,
              TContext
            >
      ): Array<
        Mutation<UpdateBlockData, UpdateBlockError, MutationVariables<UpdateBlockBody, UpdateBlockParameters>, TContext>
      >;
    };
    schema: UpdateBlockSchema;
    types: {
      parameters: UpdateBlockParameters;
      data: UpdateBlockData;
      error: UpdateBlockError;
      body: UpdateBlockBody;
    };
  };
}
/** @summary List */
export const listBlocks = {
  schema: {
    method: 'get',
    url: '/agent/blocks/',
    security: ['HTTPBearer'],
  },
} as {
  schema: ListBlocksSchema;
  [QraftServiceOperationsToken]: AgentBlocksService['listBlocks'];
};
/** @summary Create */
export const createBlock = {
  schema: {
    method: 'post',
    url: '/agent/blocks/',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: CreateBlockSchema;
  [QraftServiceOperationsToken]: AgentBlocksService['createBlock'];
};
/** @summary Template Context */
export const getTemplateContext = {
  schema: {
    method: 'get',
    url: '/agent/blocks/template_context',
  },
} as {
  schema: GetTemplateContextSchema;
  [QraftServiceOperationsToken]: AgentBlocksService['getTemplateContext'];
};
/** @summary Preview */
export const previewBlock = {
  schema: {
    method: 'post',
    url: '/agent/blocks/preview',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: PreviewBlockSchema;
  [QraftServiceOperationsToken]: AgentBlocksService['previewBlock'];
};
/** @summary Update */
export const updateBlock = {
  schema: {
    method: 'patch',
    url: '/agent/blocks/{block_id}',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: UpdateBlockSchema;
  [QraftServiceOperationsToken]: AgentBlocksService['updateBlock'];
};
export const agentBlocksService = {
  listBlocks,
  createBlock,
  getTemplateContext,
  previewBlock,
  updateBlock,
} as const;
type ListBlocksSchema = {
  method: 'get';
  url: '/agent/blocks/';
  security: ['HTTPBearer'];
};
type ListBlocksParameters = undefined;
type ListBlocksData = paths['/agent/blocks/']['get']['responses']['200']['content']['application/json'];
type ListBlocksError = unknown;
type CreateBlockSchema = {
  method: 'post';
  url: '/agent/blocks/';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type CreateBlockParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type CreateBlockData = paths['/agent/blocks/']['post']['responses']['200']['content']['application/json'];
type CreateBlockError = paths['/agent/blocks/']['post']['responses']['422']['content']['application/json'];
type CreateBlockBody = paths['/agent/blocks/']['post']['requestBody']['content']['application/json'];
type GetTemplateContextSchema = {
  method: 'get';
  url: '/agent/blocks/template_context';
};
type GetTemplateContextParameters = undefined;
type GetTemplateContextData =
  paths['/agent/blocks/template_context']['get']['responses']['200']['content']['application/json'];
type GetTemplateContextError = unknown;
type PreviewBlockSchema = {
  method: 'post';
  url: '/agent/blocks/preview';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type PreviewBlockParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type PreviewBlockData = paths['/agent/blocks/preview']['post']['responses']['200']['content']['application/json'];
type PreviewBlockError = paths['/agent/blocks/preview']['post']['responses']['422']['content']['application/json'];
type PreviewBlockBody = paths['/agent/blocks/preview']['post']['requestBody']['content']['application/json'];
type UpdateBlockSchema = {
  method: 'patch';
  url: '/agent/blocks/{block_id}';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type UpdateBlockParameters = paths['/agent/blocks/{block_id}']['patch']['parameters'];
type UpdateBlockData = paths['/agent/blocks/{block_id}']['patch']['responses']['200']['content']['application/json'];
type UpdateBlockError = paths['/agent/blocks/{block_id}']['patch']['responses']['422']['content']['application/json'];
type UpdateBlockBody = paths['/agent/blocks/{block_id}']['patch']['requestBody']['content']['application/json'];
